/**
 * useAuth Hook
 * 
 * Provides authentication state and methods.
 * This is a thin wrapper around the AppAuthContext.
 */

import { useAppAuth } from './AppAuthContext'

export function useAuth() {
  return useAppAuth()
}
